import { getRequest } from '../services/requestHandler';
import { PlayerBagsForPwaDto } from '../models';

export const getTourBagsForPWA = async (modifiedAfter?: string) => {
  // Need to build the url around the API which throws an error on a null modifiedAfter after param
  const url = modifiedAfter ? `TourBag/GetTourBagsForPWA?modifiedAfter=${modifiedAfter}` : 'TourBag/GetTourBagsForPWA';
  const response = await getRequest<PlayerBagsForPwaDto>('GetTourBagsForPWA', url);
  return response;
};
